import { EventEmitter } from "events";

const popupEmitter = new EventEmitter();

export const showBlockedPopup = () => {
  popupEmitter.emit("show");
};

export const hideBlockedPopup = () => {
  popupEmitter.emit("hide");
};

export const popupEventEmitter = popupEmitter;
